import { useNinetailedFeatureFlag } from '@ecomm/shared-ninetailed'
import type { RefObject } from 'react'

const NINETAILED_CTFL_ID_CONTROL = '5Y70pt9xhb4WL6l0tR2B93'

type Props = {
  readonly ref?: RefObject<HTMLElement>
}

/**
 * Hook to determine whether to render AI Chat or not.
 * @returns { isVariant: boolean; status: 'loading' | 'error' | 'success', enabled: boolean }
 */
export const useIsAIChatExperiment = ({ ref }: Props) => {
  const featureFlagData = useNinetailedFeatureFlag({
    baselineId: NINETAILED_CTFL_ID_CONTROL,
    intersectionRef: ref
  })

  // Kill switch for AI Chat experiment
  const enableAIChat = process.env['GATSBY_ENABLE_AI_CHAT'] === 'true'

  return { ...featureFlagData, enabled: enableAIChat }
}
